import React from "react";

const RefundPolicy = () => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4 md:p-8">
      <div className="bg-white shadow-md rounded-xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold text-[#1f3b71] mb-6">
          Refund & Cancellation Policy
        </h1>

        {/* Section 2.1 */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2.1 Cancellation Timeline
          </h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            Refund amounts depend on how far in advance you cancel your booking:
          </p>

          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>
              <span className="font-semibold">7 Days or more:</span> 90% refund
              (10% service & processing fee deducted).
            </li>
            <li>
              <span className="font-semibold">3 Days before travel:</span> 50%
              refund.
            </li>
            <li>
              <span className="font-semibold">Less than 24 Hours:</span>{" "}
              Generally Non-Refundable, but rescheduling may be offered based on
              vendor policy.
            </li>
          </ul>
        </div>

        {/* Section 2.2 */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2.2 Refund Due to Service Failure
          </h2>
          <p className="text-gray-700 leading-relaxed">
            If Dhoorbin.com or our vendor fails to provide the confirmed service
            and cannot offer an acceptable alternative, you will receive a{" "}
            <span className="font-bold">100% Full Refund</span>.
          </p>
        </div>

        {/* Section 2.3 */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2.3 Refund Processing Time
          </h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>
              Refunds are processed via the original payment method (Bank
              Transfer, Credit Card, bKash, Nagad, etc.)
            </li>
            <li>Please allow 7 to 10 working days for completion.</li>
          </ul>
        </div>

        {/* Section 2.4 */}
        <div>
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2.4 Force Majeure (Unforeseeable Circumstances)
          </h2>
          <p className="text-gray-700 leading-relaxed">
            In cases such as natural disasters, political unrest, or pandemics,
            Dhoorbin.com will not issue cash refunds. Instead, a{" "}
            <span className="font-bold">Credit Voucher</span> or free date
            change will be offered.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
